import {
  globalDeleteService,
  globalGetService,
  globalPostService,
  globalPutService,
} from '@/utils/globalApiServices';

import { CreateTrademarkParams, Trademark } from './types';

export const createTrademarks = async (
  brandUid: string,
  data: CreateTrademarkParams | CreateTrademarkParams[]
) => {
  const response = await globalPostService(
    `csp/brands/${brandUid}/trademarks`,
    Array.isArray(data) ? data : [data]
  );
  return (response?.ok ? response.data : []) as Trademark[];
};

export const getTrademarks = async (brandUid: string) => {
  const response = await globalGetService(`csp/brands/${brandUid}/trademarks`);
  return (response?.ok ? response.data : []) as Trademark[];
};

export const getTrademark = async (brandUid: string, trademarkUid: string) => {
  const response = await globalGetService(
    `csp/brands/${brandUid}/trademarks/${trademarkUid}`
  );
  return response?.ok ? (response.data as Trademark) : undefined;
};

export const deleteTrademark = async (
  brandUid: string,
  trademarkUid: string
) => {
  const response = await globalDeleteService(
    `csp/brands/${brandUid}/trademarks/${trademarkUid}`
  );
  return !!response?.ok;
};

export const verifyTrademark = async (
  brandUid: string,
  trademarkUid: string
) => {
  const response = await globalPutService(
    `csp/brands/${brandUid}/trademarks/${trademarkUid}/verify`
  );
  return response?.ok ? (response.data as Trademark) : undefined;
};
